export const darkTypography = {};

export const lightTypography = {
  fontFamily: ["Rubik"].join(","),
};
